module.exports = __webpack_public_path__ + "static/media/nova-adesao.8b80306d.svg";